'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

var header = function header(_ref) {
  var level = _ref.level,
    fontSize = _ref.fontSize;
  var StyledHeader = styled["h".concat(level)].withConfig({
    componentId: "sc-1cysdn1-0"
  })(["margin:", ";font-size:", ";font-family:", ";font-weight:", ";color:", ";"], function (props) {
    return props.s.margin || '1.5rem 0';
  }, function (props) {
    return props.s.fontSize || fontSize;
  }, function (props) {
    return props.s.fontFamily || 'inherit';
  }, function (props) {
    return props.s.fontWeight || 'bold';
  }, function (props) {
    return props.s.color || '#000';
  });
  StyledHeader.defaultProps = {
    s: {}
  };
  StyledHeader.propTypes = {
    s: PropTypes.shape({
      margin: PropTypes.string,
      fontSize: PropTypes.string,
      fontFamily: PropTypes.string,
      fontWeight: PropTypes.string,
      color: PropTypes.string
    })
  };
  return StyledHeader;
};
var HugeHeader = header({
  level: 1,
  fontSize: '5rem'
});
var BigHeader = header({
  level: 2,
  fontSize: '2.125rem'
});
var SemibigHeader = header({
  level: 3,
  fontSize: '1.5rem'
});
var MediumHeader = header({
  level: 4,
  fontSize: '1.125rem'
});
var SmallHeader = header({
  level: 5,
  fontSize: '0.875rem'
});

exports.BigHeader = BigHeader;
exports.HugeHeader = HugeHeader;
exports.MediumHeader = MediumHeader;
exports.SemibigHeader = SemibigHeader;
exports.SmallHeader = SmallHeader;
